import { clone } from 'mobx-state-tree'
import { getCurrentUser } from '../components/core/Authentication'
import { useAuth } from '../hooks/useAuth'
import { ISongStore } from '../stores/song/SongStore'
import { IStudioStore } from '../stores/StudioStore'
import { getMetadataForSong, getMetadataForStem, getSubcomponentsForStem } from './MintUtils'

const useMintToDatabase = () => {
  const { authenticatedPost } = useAuth()

  /**
   * "Mints" the given song to our temporary AWS dynamo db tables.
   * Make sure the song is added to the root
   */
  const mintSongToDatabase = async (
    studio: IStudioStore,
    song: ISongStore,
    genres?: string[],
    customArtistAddress?: string
  ) => {
    song.minimizeForStorage()
    const currentUser = await getCurrentUser()

    // Mint stems
    const stemIndices = []

    // Don't do this with forEach, since it'll make it async.
    for (let i = 0; i < song.stems.length; i++) {
      // Remixed stems
      if (!song.stems[i].isRemixed) {
        const stemClone = clone(song.stems[i])
        stemClone.trimArrangementTo(song.songRealLength)
        const index = await mintStemToDatabase(studio, stemClone, song, currentUser.walletAddress)
        stemIndices.push(index)
      } else {
        // Remixed, just push index of the stem this references
        stemIndices.push(song.stems[i].remixedStemId)
      }
    }

    // TODO, clear the stems, since we've already uploaded them elsewhere. Can use the subcomponent indices to reconstruct the song.
    //  Whenever we reconstruct the song, repopulate the stems from the DB.
    // songClone.stems.clear()

    // Construct this format to match the way data is stored on the contract.
    const metadata = {
      ...getMetadataForSong(song, genres),
      arpeggiComposition: JSON.stringify(song.serializeSongForStorage())
    }

    console.log('metadata:', metadata)

    // Construct the stem data payload
    const media = {
      artistEthAddress: currentUser.walletAddress,
      type: 'audio',
      dataUri: '', // TODO automatically record this
      metadata: metadata,
      subcomponents: stemIndices // TODO add a contract index for the stems.
    }
    console.log('uploading song: ', media)

    const index = (await authenticatedPost('/api/v1/songs/append', media)).data.index
    return index
  }

  /**
   * "Mints" the given stem to our temporary AWS dynamo db tables.
   */
  const mintStemToDatabase = async (
    studio: IStudioStore,
    stem: any,
    song: ISongStore,
    creator: string
  ) => {
    // Construct this format to match the way data is stored on the contract.
    const metadata = {
      ...getMetadataForStem(studio, stem, song),
      arpeggiComposition: JSON.stringify(stem.serializeStemForStorage())
    }

    const subcomponents = getSubcomponentsForStem(studio, stem)

    // Construct the stem data payload
    const media = {
      // index: nextStemIndex,
      artistEthAddress: creator,
      type: 'audio',
      dataUri: '', // TODO automatically record this
      metadata: metadata,
      subcomponents: subcomponents // Reference the samples!
    }
    console.log('uploading stem: ', media)

    const index = (await authenticatedPost('/api/v1/stems/append', media)).data.index
    return index
  }

  return { mintSongToDatabase, mintStemToDatabase }
}

export default useMintToDatabase
